<template>
<div>
  <div v-if="!states.viewAllow" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div v-else>
    <div v-if="localEligData.length === 0" class="row">
      <p></p>
      <div class="text-center large-12 medium-12 small-12 columns">
        <label v-html="tpl('package.unsupportedRpln')"></label>
      </div>
    </div>
    <div v-else class="row">
      <div class="text-center large-12 medium-12 small-12 columns">
        <div v-if="states.isYoung" class="swipe-alert">
          Služba SWIPE nie je na tejto stránke podporovaná. Pre pohodlné spravovanie služby SWIPE použite mobilnú aplikáciu SWIPE.
        </div>
        <div v-else>
          <p></p>
          <label>Balíčky nie sú pre váš predplatený program podporené.</label>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import pkgDef from '@/assets/js/pkgDef'

export default {
  name: 'Data',
  components: {},
  data () {
    return {
      msg: 'Dátový balík',
      seen: false,
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      msisdn: '',
      productdetail: {},
      pkgDef: pkgDef,
      moment: moment,
      states: { viewAllow: true, isYoung: false }
     }
  },
  created: function() {
    var that = this
    this.$store.commit('setAres', false)
    // this.$store.commit('headerHide', true)

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    if (_.isEmpty(this.$store.state.tplData) || _.isEmpty(this.$store.state.productdetail) || !this.$store.state.globalOldRpln) {
      this.$router.replace("/balicky")
    } else {
      this.tplData = this.$store.state.tplData;
      this.productdetail = this.$store.state.productdetail;
      this.msisdn = this.productdetail.msisdn;
        if (((this.productdetail.product.productName || '').toLowerCase()).indexOf('young') !== -1) {
          this.states.isYoung = true;
        }
    }
  },
  mounted() {
    if (this.localEligData.length > 0) {
      this.startMain();
    }
  },
  methods: {
    startMain: function() {
      // have all data, do next process
      
    },
    formatMsisdn: function(virgin) {
      return '0' + String(virgin).substring(3)
    },
    formatPrice: function (virgin, active) {
      return parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €"
    }
  },
  computed: {
    localEligData() {
      return this.$store.state.localEligData;
    }
  }
}
</script>

<style scoped>
.mfet {
  color: #E20074;
 }
.pcg-sub {
  border: 1px solid #E20074;
  position: relative;
  margin-bottom: 2rem;
}

.sub-content {
  width: 100%;
  display: flex;
  padding: 10px;
}

.pcg-sub .sub-heading {
  width: 100%;
  line-height: 2.4rem;
  color: #ffffff;
  background-color: #E20074;
  padding: 0 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

.sPkg {
  margin-bottom: 1rem;
  position: relative;
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.pcg_right {
  position: absolute;
  right: 10px;
  top: 1.6rem;
  font-size: 1.7rem;
}

.pcg-block-left {
  flex: 0 0 40px;
  position: relative;
}

.pcg-block-right {
  flex: 1;
}

.pkg_desc {
  padding: 0 10px 10px 40px;
}

.pkg_container {
  padding: 10px 10px 4px 10px;
}

.pcg-title {
  text-transform: uppercase;
}

</style>
